import { Grid } from '@material-ui/core';
import { StyledLink } from 'containers/MRhDashboard/services/styles';
import messages from 'containers/NavBarDashboard/messages';
import {
  StyledGrid,
  StyledImgIcon,
  StyledMenu,
  StyledMenuItem,
  StyledShortBody,
  StyledShortText,
} from 'containers/NavBarDashboard/styles';
import { isReverse, translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { sanlamGreen } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { CONFIG } from 'utils/globalConst';
import labels from 'utils/labels';

interface Props {
  intl: IntlShape;
  handleCloseServiceMenu: () => void;
  anchorService: HTMLElement | null;
}

const HealthCallCenter = ({
  anchorService,
  handleCloseServiceMenu,
  ...props
}: Props) => {
  const language = useSelector(getLocaleSelector);
  const { pathname } = useLocation();
  const reverse = isReverse(language);

  if (pathname !== PAGES.AMC_DASHBOARD && pathname !== PAGES.AMC_DETAILS) {
    return null;
  }

  return (
    <StyledMenu
      id="Service-menu"
      anchorEl={anchorService}
      open={Boolean(anchorService)}
      onClose={handleCloseServiceMenu}
      elevation={1}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <StyledMenuItem>
        <Grid container spacing={1}>
          <Grid item xs={2}>
            <StyledImgIcon
              src={AssuranceIcon.healthCallCenter}
              alt="auto"
              color={sanlamGreen}
              style={{ fill: 'red' }}
            />
          </Grid>
          <Grid item xs={10}>
            <Grid container direction="column">
              <Grid item xs={3}>
                <StyledShortText
                  reverse={reverse}
                  color={sanlamGreen}
                  weight="100"
                >
                  {translate(get(messages, 'service_assitance'), props)}
                </StyledShortText>
              </Grid>
              <StyledGrid item xs={12}>
                <StyledLink
                  href={`tel:${CONFIG.healthCallCenterPhoneNumberFr}`}
                >
                  <strong>
                    <StyledShortBody color={sanlamGreen} weight="900">
                      {translate({ id: labels.callAmcCallCenter }, props, {
                        phoneNumber: reverse
                          ? CONFIG.healthCallCenterPhoneNumberAr
                          : CONFIG.healthCallCenterPhoneNumberFr,
                      })}
                    </StyledShortBody>
                  </strong>
                </StyledLink>
              </StyledGrid>
            </Grid>
          </Grid>
        </Grid>
      </StyledMenuItem>
    </StyledMenu>
  );
};

export default injectIntl(HealthCallCenter);
